<template>
  <modal-component
    :is-displayed="isNewCustomerModalOpened"
    :no-padding="true"
    :title="$t('ICDManagement.CreateTitleTag')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <form-wrapper :is-form-in-modal="true">
      <form @submit.prevent="handleSubmit">
        <form-divider>
          <div class="flex items-center gap-2">
            <input-field
              v-model="customer.name"
              :label="$t('ICDManagement.Name')"
              :error-message="v$?.customer['name']?.$errors[0]?.$message"
              :is-error="v$?.customer['name']?.$error"
              :required="true"
            />
          </div>
        </form-divider>
        <button-wrapper :is-submit-loading="isSubmitLoading" />
      </form>
    </form-wrapper>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import FormWrapper from "@/core/Components/FormElements/FormWrapper.vue";
import FormDivider from "@/core/Components/FormElements/FormDivider.vue";
import SmallLoader from "@/core/Components/SmallLoader.vue";
import VSelect from "vue-select";
import ButtonWrapper from "@/core/Components/FormElements/ButtonWrapper.vue";
import TheButton from "@/core/Components/TheButton.vue";
import InputField from "@/core/Components/FormElements/InputField.vue";
import { useToast } from "vue-toastification";
import { ErrorMessageFormatter, isString } from "@/core/Services/GlobalFunctions";
import useValidate from "@vuelidate/core";
import { maxLength, minLength, required } from "@vuelidate/validators";
import TextBoxMask from "@/core/Components/FormElements/TextBoxMask.vue";

import "devextreme/dist/css/dx.light.css";

import { DxTextBox } from "devextreme-vue/text-box";
import { CreateCustomer, ICDCustomer } from "../../Services/ICDManagementTypes";
import IcdService from "../../Services/ICDManagementService";

export default defineComponent({
  components: {
    ButtonWrapper,
    VSelect,
    SmallLoader,
    FormDivider,
    FormWrapper,
    ModalComponent,
    TextBoxMask,
    DxTextBox,
    TheButton,
    InputField,
  },
  props: {
    isNewCustomerModalOpened: Boolean,
    isError: Boolean,
    refreshData: {
      type: Function,
      required: true,
    },
  },
  emits: ["toggle-modal", "get-customer"],
  data() {
    return {
      toast: useToast(),
      v$: useValidate(),
      icdService: new IcdService(),
      isSubmitLoading: false,
      Customers: [] as ICDCustomer[],
      customer: {
        name: "",
      } as CreateCustomer,
    };
  },
  validations() {
    return {
      customer: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(100),
        },
      },
    };
  },
  async created() {
    try {
    } catch (error: any) {
      if (!isString(error.response.data)) {
        this.toast.error(ErrorMessageFormatter(error));
        return;
      }
      this.toast.error(error.response.data);
    }
  },
  methods: {
    async handleSubmit() {
      this.isSubmitLoading = true;
      try {
        await this.v$.$validate();
        if (this.v$.$error) {
          return;
        }
        const customerId = await this.icdService.createCustomer(this.customer);
        this.customer = { ...this.customer, ...customerId };
        this.$emit("get-customer", this.customer);
        this.$emit("toggle-modal");
        this.toast.success("New tag name created successfully!");
        await this.refreshData();
      } catch (error: any) {
        if (!isString(error.response.data)) {
          this.toast.error(ErrorMessageFormatter(error));
          return;
        }
        this.toast.error(error.response.data);
      } finally {
        this.isSubmitLoading = false;
      }
    },
  },
});
</script>

<style scoped></style>
